// UTF-8 through percent-encoding: works wherever btoa does (jsdom has no
// TextEncoder).
export function toBase64Url(text) {
	const binary = encodeURIComponent(text).replace(/%([0-9A-F]{2})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
	return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function fromBase64Url(text) {
	const padded = text.replace(/-/g, '+').replace(/_/g, '/') + '==='.slice((text.length + 3) % 4);
	const binary = atob(padded);
	return decodeURIComponent(Array.from(binary, ch => `%${ch.charCodeAt(0).toString(16).padStart(2, '0')}`).join(''));
}
